import React, { FC } from 'react';
import clsx from 'clsx';

interface LoadingProps {
  size?: '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x';
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const Loading: FC<LoadingProps> = ({ size, className, ...rest }) => {
  const cls = clsx(
    'medq-spinner',
    {
      'medq-spinner--2x': size === '2x',
      'medq-spinner--3x': size === '3x',
      'medq-spinner--4x': size === '4x',
      'medq-spinner--5x': size === '5x',
      'medq-spinner--6x': size === '6x',
      'medq-spinner--7x': size === '7x',
      'medq-spinner--8x': size === '8x',
    },
  );

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={clsx('loading-container', className)} {...rest}>
      <div className={cls} />
    </div>
  );
};

export default Loading;
